import { investigationStatusValueToLabel } from '@/constants/statuses'
import { Chip } from '@mui/material'

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  'wc-item-created': { bg: '#ECEFF1', text: '#455A64' },
  'wc-item-duplicate-check': { bg: '#FFF8E1', text: '#F57F17' },
  'wc-item-system-id-check': { bg: '#E1F5FE', text: '#0277BD' },
  'wc-item-approved': { bg: '#E8F5E9', text: '#1B5E20' },
  'wc-item-rejected': { bg: '#FFEBEE', text: '#C62828' },
  'wc-item-refunded': { bg: '#FFCDD2', text: '#B71C1C' },
  'wc-item-investigation-start': { bg: '#ECEFF1', text: '#455A64' },
  'wc-item-investigation-pending': { bg: '#FFF8E1', text: '#F57F17' },
  'wc-item-investigation-results-ready': { bg: '#E8F5E9', text: '#1B5E20' },
  'wc-item-investigation-results-shared': { bg: '#E0F7FA', text: '#00838F' }
}

const DEFAULT_COLOR = { bg: '#F3F4F6', text: '#374151' }

export default function InvestigationStatusBadge({ status }: { status: string }) {
  const label = investigationStatusValueToLabel(status)
  const color = STATUS_COLORS[status] ?? DEFAULT_COLOR

  return (
    <Chip
      label={label}
      size='small'
      sx={{
        backgroundColor: color.bg,
        color: color.text,
        fontWeight: 600,
        fontSize: '12px',
        borderRadius: '6px'
      }}
    />
  )
}
